import React, { useState, useEffect, useReducer } from 'react';
import { ButtonBase } from '@material-ui/core';
import Joi, { valid } from 'joi';
import { useTranslation } from 'react-i18next';
import { Spinner  , PermissionsComponent} from '../../../../../Components';
import { CommunicationsIds } from '../../../../../Enums';
import { GetParams, showError, showSuccess   } from '../../../../../Helper'; 
import { DevelopersPermissions } from '../../../../../Permissions' ; 
import { Button, Chip, CircularProgress } from '@material-ui/core';

import {
  GetDeveloperEmployeessAPI,
  CreateDeveloperEmployeeAPI,
  ExportDeveloperEmployeesReport,
  BulkImportEmployeesDeveloper,
} from '../../../../../Services';

import {
  DeveloperEmployeesTable,
  DeveloperEmployeesManagementComponent,
} from './DeveloperEmployeesComponents';

export const DeveloperEmployees = ({
  translationPath,
  parentTranslationPath,
}) => {
  const { t } = useTranslation(parentTranslationPath, 'Shared');
  const developerId = +GetParams('id');
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: 25,
    search: '',
  });
  const [isReloadData, setIsReloadData] = useState(null);
  const [isCanSave, setIsCanSave] = useState({
    vaildEmail: false,
    validMobile: false,
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [isCheckIsValidValues, setIsCheckIsValidValues] = useState(false);
  const [communicationsIdsValues, setCommunicationsIdsValues] = useState({
    email: CommunicationsIds.email.value,
    mobile: CommunicationsIds.mobile.value,
  });

  const [isLoading, setIsLoading] = useState({
    allDeveloperEmployees: false,
    addDeveloperEmployee: false,
    isDownloadingReport: false,
  });
  const [uploadFile, setUploadFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const [items, setItems] = useState({
    allDeveloperEmployees: {
      result: [],
      totalCount: 0,
    },
  });

  const [defaultState, setDefaultState] = useState({
    developerContactId: developerId,
    employeeName: null,
    jobTitle: null,
    linkedInProfile: null,
    employeePhoto: null,
    files: null,
    branchLocationId: null,
  });

  const [defaultSelected, setDefaultSelected] = useState({
    employeePhoto: null,
    emailAddresses: [],
    mobileNumbers: [],
    branchLocation: null,
  });

  const reducer = (select, action) => {
    if (action.id !== 'edit') return { ...select, [action.id]: action.value };
    if (action.id === 'edit') {
      return {
        ...action.value,
      };
    }
  };

  const reducer2 = (select, action) => {
    if (action.id !== 'edit') return { ...select, [action.id]: action.value };
    if (action.id === 'edit') {
      return {
        ...action.value,
      };
    }
  };


  const handleDownloadTemplate = () => {
    const link = document.createElement('a');
    link.href = '/files/Developer_Employees.xlsx';
    link.download = 'Developer_Employees.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUploadEmployees = async () => {
    if (!uploadFile) {
      showError(t('Please choose a file to upload.'));
      return;
    }

    setIsUploading(true);

    try {
      const res = await BulkImportEmployeesDeveloper(+GetParams('id'), uploadFile);
      if (res && res.status && res.status !== 200) {
        showError(t(res.message || 'Upload failed.'));
      } else {
        showSuccess(t('Employees bulk upload started.'));
        reloadData();
      }
    } catch (error) {
      showError(t(error.message || 'Upload failed.'));
    }

    setIsUploading(false);
    setUploadFile(null);
  };


  const [state, setState] = useReducer(reducer, {
    ...defaultState,
  });

  const [selected, setSelected] = useReducer(reducer2, {
    ...defaultSelected,
  });

  const schema = Joi.object({
    employeeName: Joi.string()
      .required()
      .messages({
        'string.base': t(`employee-name-is-required`),
        'string.empty': t(`employee-name-is-required`),
        'string.required': t(`employee-name-is-required`),
      }),
  })
    .options({
      abortEarly: false,
      allowUnknown: true,
    })
    .validate(state);

  const GetDeveloperEmployeesseveloperContactId = async (search) => {
    setIsLoading((item) => ({ ...item, allDeveloperEmployees: true }));
    const rs = await GetDeveloperEmployeessAPI(developerId, {
      pageIndex: filter.pageIndex + 1,
      pageSize: filter.pageSize,
      name: search,
    });
    if (!rs) {
      setItems((item) => ({
        ...item,
        allDeveloperEmployees: { result: [], totalCount: 0 },
      }));
      return;
    } else {
      setItems((item) => ({
        ...item,
        allDeveloperEmployees: {
          result: rs?.result || [],
          totalCount: rs.totalCount || 0,
        },
      }));
    }
    setIsLoading((item) => ({ ...item, allDeveloperEmployees: false }));
  };

  const reloadData = () => {
    setState({ id: 'edit', value: defaultState });
    setSelected({ id: 'edit', value: defaultSelected });
    GetDeveloperEmployeesseveloperContactId();
  };

  const onChangeHandler = (key, values, selectedObj, selectedValues) => {
    if (!selectedObj) {
      setState({ id: [key], value: values });
    } else {
      setState({ id: [key], value: values });
      setSelected({ id: [selectedObj], value: selectedValues });
    }
  };

  const handleExportDeveloperEmployeesReport = async () => {
    setIsLoading((item) => ({ ...item, isDownloadingReport: true }));
    const res = await ExportDeveloperEmployeesReport({
      developerId: developerId,
    });
    if (res && res.status && res.status !== 200) {
      showError(t('Problem requesting service from the server'));
    } else {
      showSuccess(
        t(
          'The File in Process When Job Done, We Will Send Notification in Menu for You'
        )
      );
    }
    setIsLoading((item) => ({ ...item, isDownloadingReport: false }));
  };

  const CreateDeveloperEmployeeHandler = async () => {
    setIsLoading((item) => ({ ...item, addDeveloperEmployee: true }));
    const body = {
      ...state,
      developerEmployeeCommunications: [
        ...selected.emailAddresses?.filter((c) => c.communicationValue !== ''),
        ...selected.mobileNumbers,
      ],
    };
    if (state.files) delete body.files;
    const res = await CreateDeveloperEmployeeAPI(body);
    if (!(res && res.status && res.status !== 200)) {
      showSuccess(t`developer-employee-created-successfully`);
      setIsLoading((item) => ({ ...item, addDeveloperEmployee: false }));
      setIsReloadData(
        isReloadData === null || isReloadData === false ? true : false
      );
      reloadData();
    } else {
      showError(t`developer-employee-create-failed`);
      setIsLoading((item) => ({ ...item, addDeveloperEmployee: false }));
    }
  };

  useEffect(() => {
    reloadData();
  }, [filter]);

  return (
    <div className="agreement-details-deveoloper-wrapper childs-wrapper d-flex-column">
      <div className="w-100 agreement-details-add">
        <Spinner
          isActive={
            isLoading.allDeveloperEmployees || isLoading.addDeveloperEmployee
          }
          isAbsolute
        />
        <div className="w-100">
          <div className="part1 mt-2 mb-2">
            <DeveloperEmployeesManagementComponent
              translationPath={translationPath}
              parentTranslationPath={parentTranslationPath}
              state={state}
              setState={setState}
              onChangeHandler={onChangeHandler}
              className={"px-2 item mt-1"}
              selected={selected}
              setSelected={setSelected}
              key={"save"}
              schema={schema}
              isReloadData={isReloadData}
              setIsCheckIsValidValues={setIsCheckIsValidValues}
              communicationsIdsValues={communicationsIdsValues}
              setIsCanSave={setIsCanSave}
              isCanSave={isCanSave}
            />

            <div className="d-flex-v-center-h-end flex-wrap">
              <ButtonBase
                className="btns theme-solid"
                onClick={handleExportDeveloperEmployeesReport}
                disabled={
                  items?.allDeveloperEmployees?.result.length === 0 ||
                  isLoading.isDownloadingReport
                }
              >
                {t(`export-report`)}
              </ButtonBase>
              <PermissionsComponent
                permissionsList={[...Object.values(DevelopersPermissions)]}
                permissionsId={DevelopersPermissions.DownloadEmployees.permissionsId}
              >
                <ButtonBase
                  className="btns theme-solid"
                  onClick={handleDownloadTemplate}
                >
                  {t("download-template")}
                </ButtonBase>
              </PermissionsComponent>
              <ButtonBase
                className="btns theme-solid"
                onClick={CreateDeveloperEmployeeHandler}
                disabled={
                  isLoading.addDeveloperEmployee ||
                  isCheckIsValidValues ||
                  state.employeeName === "" ||
                  !state.employeeName ||
                  isCanSave.vaildEmail ||
                  isCanSave.validMobile
                }
              >
                <span className="mdi mdi-plus" />
                {t(`add-developer-employee`)}
              </ButtonBase>
            </div>
            <PermissionsComponent
                permissionsList={[...Object.values(DevelopersPermissions)]}
                permissionsId={DevelopersPermissions.BulkUploadEmployees.permissionsId}
              >
            <div className='flex w-50'>
              <div className="d-flex-v-center-h-end flex-wrap mt-3">
              <div className="input-theme-component-wrapper fixed-height">
                <div className="dropzone-wrapper">
                  {uploadFile && (
                    <Chip
                      className="uploader-chip"
                      label={uploadFile.name}
                      onDelete={() => {
                        setUploadFile(null);
                        document.getElementById("file-upload-input").value = "";
                      }}
                    />
                  )}
                </div>

                <Button
                  className="btns theme-transparent mx-0"
                  onClick={() =>
                    document.getElementById("file-upload-input").click()
                  }
                  disabled={isUploading}
                >
                  <span className="mx-3 text-nowrap">
                    {t("Shared:uploaderComponent.browse-file")}
                  </span>
                </Button>

                <input
                  type="file"
                  id="file-upload-input"
                  accept=".xlsx, .xls"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setUploadFile(file);
                    }
                  }}
                />
              </div>
              <ButtonBase
                className="btns theme-solid mt-3"
                onClick={handleUploadEmployees}
                disabled={uploadFile === null || isUploading}
              >
                {t(isUploading ? "uploading..." : "Upload")}
              </ButtonBase>
            </div>
            </div>
            </PermissionsComponent>
          </div>
        </div>
      </div>
      <DeveloperEmployeesTable
        translationPath={translationPath}
        parentTranslationPath={parentTranslationPath}
        data={items.allDeveloperEmployees}
        filter={filter}
        setFilter={setFilter}
        reloadData={reloadData}
        communicationsIdsValues={communicationsIdsValues}
        isReloadData={isReloadData}
        setIsReloadData={setIsReloadData}
      />
    </div>
  );
};
